import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import JustificationListItem from './JustificationListItem';
import * as justificationAction from '../../../actions/justificationAction';
import { BackButton, Title, Subtitle, InfiniteScroll } from '../../../components/UI/ComponentsUI';
import { translate } from '../../../utils/util';
import JustificationService from '../../../services/JustificationService';
import { ENUMS } from '../../../utils/constants';

const JustificationList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [justifications, setJustifications] = useState([]);

    useEffect(() => {
        if (props.justifications?.items?.length > 0) {
            if (justifications.length > 0 && currentPage === 0) {
                setJustifications(props.justifications.items);
            } else {
                setJustifications((prevState) => ([...prevState, ...props.justifications.items]));
            }
        } else {
            setJustifications([]);
        }
        // eslint-disable-next-line
    }, [props?.justifications?.items]);

    useEffect(() => {
        props.getJustifications(props.user.vision, {
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        if (!props.justificationsType || props.justificationsType?.length === 0) {
            props.getJustificationsType();
        }
        // eslint-disable-next-line
    }, []);

    const onSelectItemChange = (justification) => {
        props.setJustification(justification);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                    <Subtitle icon="mdi mdi-folder-text-outline" label={translate('menu.justification', 'configuration')} />
                </div>
            </div>
            {
                justifications && (
                    <div className="container-fluid" style={{ marginTop: '25px', }}>
                        <div id="ListItemsJustification" className="container-fluid">
                            <InfiniteScroll
                                page={props.justifications?.totalPages}
                                hasMore={currentPage < props.justifications?.totalPages}
                                current={{ currentPage, setCurrentPage }}
                                data={justifications.map((item, index) => {
                                    return (
                                        <JustificationListItem
                                            // eslint-disable-next-line react/no-array-index-key
                                            key={`oi-${index}`}
                                            route={{ pathname: '../justification/insert', state: { update: true } }}
                                            data={item}
                                            justificationTypes={props.justificationsType}
                                            onSelectChange={() => onSelectItemChange(item)}
                                        />
                                    );
                                })}
                            />
                        </div>
                    </div>
                )
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justifications: state.justificationReducer.justifications,
        justificationsType: state.justificationReducer.justificationsType
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getJustifications: (vision, filter, pagination) => {
            dispatch(JustificationService.getJustifications(vision, filter, pagination));
        },
        setJustification: (justification) => {
            dispatch(justificationAction.setJustification(justification));
        },
        getJustificationsType: () => {
            dispatch(JustificationService.getJustificationsType());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JustificationList));
